import * as React from 'react'

const Wheel2 = props => {
  return (
    <svg
      viewBox="0 0 349 349"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M317.619 78.7715L316.811 81.709L320.631 79.2271L317.619 78.7715Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M320.631 79.2285L316.811 81.7104L319.823 82.1638L320.631 79.2285Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7246 266.381L27.9141 269.318L31.7366 266.836L28.7246 266.381Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.7366 266.836L27.9141 269.318L30.9261 269.771L31.7366 266.836Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M326.817 94.2754L325.704 97.1121L329.765 95.0421L326.817 94.2754Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M329.765 95.041L325.704 97.1111L328.653 97.8778L329.765 95.041Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.894 250.666L18.7812 253.501L22.8425 251.433L19.894 250.666Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.8425 251.432L18.7812 253.5L21.7297 254.266L22.8425 251.432Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M334.345 110.664L332.94 113.367L337.197 111.733L334.345 110.664Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M337.197 111.734L332.94 113.369L335.793 114.44L337.197 111.734Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7557 234.107L11.3516 236.811L15.6056 235.179L12.7557 234.107Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6056 235.18L11.3516 236.812L14.2036 237.883L15.6056 235.18Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M340.115 127.74L338.438 130.281L342.838 129.103L340.115 127.74Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M342.838 129.102L338.438 130.28L341.16 131.645L342.838 129.102Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.38401 216.895L5.70605 219.436L10.109 218.257L7.38401 216.895Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.109 218.256L5.70605 219.434L8.43108 220.799L10.109 218.256Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M344.07 145.334L342.136 147.687L346.637 146.975L344.07 145.334Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346.637 146.973L342.136 147.685L344.703 149.325L346.637 146.973Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.84464 199.219L1.9082 201.571L6.40976 200.857L3.84464 199.219Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.40976 200.855L1.9082 201.57L4.47551 203.21L6.40976 200.855Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346.166 163.242L343.995 165.38L348.547 165.141L346.166 163.242Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M348.547 165.143L343.995 165.381L346.376 167.281L348.547 165.143Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16863 181.268L0 183.406L4.55194 183.167L2.16863 181.268Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.55194 183.166L0 183.405L2.38111 185.304L4.55194 183.166Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346.376 181.268L343.995 183.167L348.547 183.406L346.376 181.268Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M348.547 183.405L343.995 183.166L346.166 185.304L348.547 183.405Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.38111 163.242L0 165.141L4.55194 165.38L2.38111 163.242Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.55194 165.381L0 165.143L2.16863 167.281L4.55194 165.381Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M344.703 199.219L342.136 200.857L346.637 201.571L344.703 199.219Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346.637 201.57L342.136 200.855L344.07 203.21L346.637 201.57Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.47551 145.334L1.9082 146.975L6.40976 147.687L4.47551 145.334Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.40976 147.685L1.9082 146.973L3.84464 149.325L6.40976 147.685Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M341.16 216.895L338.438 218.257L342.838 219.436L341.16 216.895Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M342.838 219.434L338.438 218.256L340.115 220.799L342.838 219.434Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.43108 127.74L5.70605 129.103L10.109 130.281L8.43108 127.74Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.109 130.28L5.70605 129.102L7.38401 131.645L10.109 130.28Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M335.793 234.107L332.94 235.179L337.197 236.811L335.793 234.107Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M337.197 236.812L332.94 235.18L334.345 237.883L337.197 236.812Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2036 110.664L11.3516 111.735L15.6056 113.369L14.2036 110.664Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6056 113.369L11.3516 111.734L12.7557 114.44L15.6056 113.369Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M328.653 250.666L325.704 251.433L329.765 253.501L328.653 250.666Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M329.765 253.5L325.704 251.432L326.817 254.266L329.765 253.5Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7297 94.2754L18.7812 95.0421L22.8425 97.1121L21.7297 94.2754Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.8425 97.1111L18.7812 95.041L19.894 97.8778L22.8425 97.1111Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M319.823 266.381L316.811 266.836L320.631 269.318L319.823 266.381Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M320.631 269.318L316.811 266.836L317.619 269.771L320.631 269.318Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.9261 78.7715L27.9141 79.2271L31.7366 81.709L30.9261 78.7715Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.7366 81.7104L27.9141 79.2285L28.7246 82.1638L31.7366 81.7104Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M309.396 281.092L306.354 281.23L309.896 284.097L309.396 281.092Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M309.896 284.098L306.354 281.23L306.853 284.236L309.896 284.098Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.695 64.3125L38.6523 64.4483L42.1944 67.3179L41.695 64.3125Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.1944 67.3169L38.6523 64.4473L39.1496 67.4527L42.1944 67.3169Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M297.491 294.631L294.45 294.449L297.672 297.671L297.491 294.631Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M297.672 297.671L294.45 294.449L294.632 297.49L297.672 297.671Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.9157 51.0529L50.873 50.8711L54.0975 54.0956L53.9157 51.0529Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.0975 54.0956L50.873 50.8711L51.0571 53.9116L54.0975 54.0956Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M284.235 306.853L281.229 306.354L284.097 309.896L284.235 306.853Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M284.097 309.896L281.23 306.354L281.092 309.396L284.097 309.896Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.4527 39.1476L64.4473 38.6504L67.3169 42.1903L67.4527 39.1476Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.3169 42.1903L64.4473 38.6504L64.3115 41.693L67.3169 42.1903Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M269.773 317.621L266.838 316.811L269.32 320.633L269.773 317.621Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M269.319 320.633L266.837 316.811L266.382 319.823L269.319 320.633Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.1629 28.7246L79.2275 27.9141L81.7094 31.7366L82.1629 28.7246Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.709 31.7366L79.2271 27.9141L78.7715 30.9261L81.709 31.7366Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M254.266 326.816L251.432 325.703L253.5 329.764L254.266 326.816Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M253.5 329.764L251.432 325.703L250.665 328.652L253.5 329.764Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.8817 19.8921L95.0449 18.7793L97.115 22.8384L97.8817 19.8921Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.1151 22.8384L95.045 18.7793L94.2783 21.7278L97.1151 22.8384Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M237.884 334.344L235.181 332.939L236.813 337.193L237.884 334.344Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M236.812 337.193L235.181 332.939L234.109 335.792L236.812 337.193Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.439 12.7516L111.733 11.3496L113.368 15.6036L114.439 12.7516Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.367 15.6036L111.733 11.3496L110.664 14.2017L113.367 15.6036Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.804 340.113L218.261 338.436L219.441 342.836L220.804 340.113Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.442 342.836L218.261 338.436L216.898 341.158L219.442 342.836Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.649 7.38303L129.105 5.70508L130.286 10.1081L131.649 7.38303Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130.286 10.1081L129.106 5.70508L127.743 8.43011L130.286 10.1081Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M203.214 344.069L200.859 342.135L201.573 346.636L203.214 344.069Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M201.573 346.636L200.859 342.135L199.221 344.702L201.573 346.636Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M149.326 3.8405L146.974 1.90625L147.686 6.40781L149.326 3.8405Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M147.686 6.40781L146.974 1.90625L145.333 4.47356L147.686 6.40781Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M185.307 346.165L183.169 343.996L183.408 348.548L185.307 346.165Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M183.407 348.548L183.169 343.996L181.27 346.377L183.407 348.548Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.279 2.16863L165.141 0L165.379 4.54975L167.279 2.16863Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M165.379 4.54975L165.14 0L163.241 2.38112L165.379 4.54975Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.279 346.377L165.379 343.996L165.141 348.548L167.279 346.377Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M165.14 348.548L165.379 343.996L163.241 346.165L165.14 348.548Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M185.307 2.38112L183.408 0L183.169 4.54975L185.307 2.38112Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M183.169 4.54975L183.407 0L181.27 2.16863L183.169 4.54975Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M149.326 344.702L147.686 342.135L146.974 346.636L149.326 344.702Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M146.974 346.636L147.686 342.135L145.333 344.069L146.974 346.636Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M203.214 4.47356L201.573 1.90625L200.859 6.40781L203.214 4.47356Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M200.859 6.40781L201.573 1.90625L199.221 3.8405L200.859 6.40781Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.649 341.158L130.286 338.436L129.105 342.836L131.649 341.158Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.106 342.836L130.286 338.436L127.743 340.113L129.106 342.836Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.804 8.43011L219.441 5.70508L218.261 10.1081L220.804 8.43011Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.261 10.1081L219.442 5.70508L216.898 7.38303L218.261 10.1081Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.439 335.792L113.368 332.939L111.733 337.193L114.439 335.792Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.733 337.193L113.367 332.939L110.664 334.344L111.733 337.193Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M237.884 14.2017L236.813 11.3496L235.181 15.6036L237.884 14.2017Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M235.181 15.6036L236.812 11.3496L234.109 12.7516L235.181 15.6036Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.8817 328.652L97.115 325.703L95.0449 329.764L97.8817 328.652Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.045 329.764L97.1151 325.703L94.2783 326.816L95.045 329.764Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M254.266 21.7278L253.5 18.7793L251.432 22.8384L254.266 21.7278Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M251.432 22.8384L253.5 18.7793L250.665 19.8921L251.432 22.8384Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.1629 319.823L81.7094 316.811L79.2275 320.633L82.1629 319.823Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.2271 320.633L81.709 316.811L78.7715 317.621L79.2271 320.633Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M269.773 30.9261L269.32 27.9141L266.838 31.7366L269.773 30.9261Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M266.837 31.7366L269.319 27.9141L266.382 28.7246L266.837 31.7366Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.4527 309.396L67.3169 306.354L64.4473 309.896L67.4527 309.396Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.4473 309.896L67.3169 306.354L64.3115 306.853L64.4473 309.896Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M284.235 41.693L284.097 38.6504L281.229 42.1903L284.235 41.693Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M281.23 42.1903L284.097 38.6504L281.092 39.1476L281.23 42.1903Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.9157 297.49L54.0975 294.449L50.873 297.671L53.9157 297.49Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.873 297.671L54.0975 294.449L51.0571 294.631L50.873 297.671Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M297.491 53.9116L297.672 50.8711L294.45 54.0956L297.491 53.9116Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M294.45 54.0956L297.672 50.8711L294.632 51.0529L294.45 54.0956Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.695 284.236L42.1944 281.23L38.6523 284.098L41.695 284.236Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.6523 284.097L42.1944 281.23L39.1496 281.092L38.6523 284.097Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M309.396 67.4527L309.896 64.4473L306.354 67.3169L309.396 67.4527Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306.354 67.3179L309.896 64.4483L306.853 64.3125L306.354 67.3179Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.9261 269.771L31.7366 266.836L27.9141 269.318L30.9261 269.771Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.9141 269.318L31.7366 266.836L28.7246 266.381L27.9141 269.318Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M319.823 82.1638L320.631 79.2285L316.811 81.7104L319.823 82.1638Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M316.811 81.709L320.631 79.2271L317.619 78.7715L316.811 81.709Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7297 254.266L22.8425 251.432L18.7812 253.5L21.7297 254.266Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7812 253.501L22.8425 251.433L19.894 250.666L18.7812 253.501Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M328.653 97.8778L329.765 95.041L325.704 97.1111L328.653 97.8778Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M325.704 97.1121L329.765 95.0421L326.817 94.2754L325.704 97.1121Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2036 237.883L15.6056 235.18L11.3516 236.812L14.2036 237.883Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3516 236.811L15.6056 235.179L12.7557 234.107L11.3516 236.811Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M335.793 114.44L337.197 111.734L332.94 113.369L335.793 114.44Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M332.94 113.369L337.197 111.735L334.345 110.664L332.94 113.369Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.43108 220.799L10.109 218.256L5.70605 219.434L8.43108 220.799Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.70605 219.436L10.109 218.257L7.38401 216.895L5.70605 219.436Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M341.16 131.645L342.838 129.102L338.438 130.28L341.16 131.645Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M338.438 130.281L342.838 129.103L340.115 127.74L338.438 130.281Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.47551 203.21L6.40976 200.855L1.9082 201.57L4.47551 203.21Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.9082 201.571L6.40976 200.857L3.84464 199.219L1.9082 201.571Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M344.703 149.325L346.637 146.973L342.136 147.685L344.703 149.325Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M342.136 147.687L346.637 146.975L344.07 145.334L342.136 147.687Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.38111 185.304L4.55194 183.166L0 183.405L2.38111 185.304Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 183.406L4.55194 183.167L2.16863 181.268L0 183.406Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346.376 167.281L348.547 165.143L343.995 165.381L346.376 167.281Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M343.995 165.38L348.547 165.141L346.166 163.242L343.995 165.38Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16863 167.281L4.55194 165.381L0 165.143L2.16863 167.281Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 165.141L4.55194 165.38L2.38111 163.242L0 165.141Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346.166 185.304L348.547 183.405L343.995 183.166L346.166 185.304Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M343.995 183.167L348.547 183.406L346.376 181.268L343.995 183.167Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.84464 149.325L6.40976 147.685L1.9082 146.973L3.84464 149.325Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.9082 146.975L6.40976 147.687L4.47551 145.334L1.9082 146.975Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M344.07 203.21L346.637 201.57L342.136 200.855L344.07 203.21Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M342.136 200.857L346.637 201.571L344.703 199.219L342.136 200.857Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.38401 131.645L10.109 130.28L5.70605 129.102L7.38401 131.645Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.70605 129.103L10.109 130.281L8.43108 127.74L5.70605 129.103Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M340.115 220.799L342.838 219.434L338.438 218.256L340.115 220.799Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M338.438 218.257L342.838 219.436L341.16 216.895L338.438 218.257Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7557 114.44L15.6056 113.369L11.3516 111.734L12.7557 114.44Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3516 111.733L15.6056 113.367L14.2036 110.664L11.3516 111.733Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M334.345 237.883L337.197 236.812L332.94 235.18L334.345 237.883Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M332.94 235.179L337.197 236.811L335.793 234.107L332.94 235.179Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.894 97.8778L22.8425 97.1111L18.7812 95.041L19.894 97.8778Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7812 95.0421L22.8425 97.1121L21.7297 94.2754L18.7812 95.0421Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M326.817 254.266L329.765 253.5L325.704 251.432L326.817 254.266Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M325.704 251.433L329.765 253.501L328.653 250.666L325.704 251.433Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7246 82.1638L31.7366 81.7104L27.9141 79.2285L28.7246 82.1638Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.9141 79.2271L31.7366 81.709L30.9261 78.7715L27.9141 79.2271Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M317.619 269.771L320.631 269.318L316.811 266.836L317.619 269.771Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M316.811 266.836L320.631 269.318L319.823 266.381L316.811 266.836Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.1496 67.4527L42.1944 67.3169L38.6523 64.4473L39.1496 67.4527Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.6523 64.4483L42.1944 67.3179L41.695 64.3125L38.6523 64.4483Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306.853 284.236L309.896 284.098L306.354 281.23L306.853 284.236Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306.354 281.23L309.896 284.097L309.396 281.092L306.354 281.23Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.0571 53.9137L54.0975 54.0956L50.873 50.8711L51.0571 53.9137Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.873 50.8711L54.0975 54.0956L53.9157 51.0529L50.873 50.8711Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M294.632 297.49L297.672 297.671L294.45 294.449L294.632 297.49Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M294.45 294.449L297.672 297.671L297.491 294.631L294.45 294.449Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.3115 41.693L67.3169 42.1903L64.4473 38.6504L64.3115 41.693Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.4473 38.6504L67.3169 42.1903L67.4527 39.1476L64.4473 38.6504Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M281.092 309.396L284.097 309.896L281.23 306.354L281.092 309.396Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M281.229 306.354L284.097 309.896L284.235 306.853L281.229 306.354Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.7715 30.9261L81.709 31.7366L79.2271 27.9141L78.7715 30.9261Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.2275 27.9141L81.7094 31.7366L82.1629 28.7246L79.2275 27.9141Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M266.382 319.823L269.319 320.633L266.837 316.811L266.382 319.823Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M266.838 316.811L269.32 320.633L269.773 317.621L266.838 316.811Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.2783 21.7278L97.1151 22.8384L95.045 18.7793L94.2783 21.7278Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.0449 18.7793L97.115 22.8384L97.8817 19.8921L95.0449 18.7793Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M250.665 328.652L253.5 329.764L251.432 325.703L250.665 328.652Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M251.432 325.703L253.5 329.764L254.266 326.816L251.432 325.703Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.664 14.2017L113.367 15.6036L111.733 11.3496L110.664 14.2017Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.733 11.3496L113.368 15.6036L114.439 12.7516L111.733 11.3496Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M234.109 335.792L236.812 337.193L235.181 332.939L234.109 335.792Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M235.181 332.939L236.813 337.193L237.884 334.344L235.181 332.939Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M127.743 8.43011L130.286 10.1081L129.106 5.70508L127.743 8.43011Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.105 5.70508L130.286 10.1081L131.649 7.38303L129.105 5.70508Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M216.898 341.158L219.442 342.836L218.261 338.436L216.898 341.158Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.261 338.436L219.441 342.836L220.804 340.113L218.261 338.436Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M145.333 4.47356L147.686 6.40781L146.974 1.90625L145.333 4.47356Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M146.974 1.90625L147.686 6.40781L149.326 3.84269L146.974 1.90625Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M199.221 344.702L201.573 346.636L200.859 342.135L199.221 344.702Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M200.859 342.135L201.573 346.636L203.214 344.069L200.859 342.135Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M163.241 2.38112L165.379 4.54975L165.14 0L163.241 2.38112Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M165.141 0L165.379 4.54975L167.279 2.16863L165.141 0Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M181.27 346.377L183.407 348.548L183.169 343.996L181.27 346.377Z"
        fill="#F6D69B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M183.169 343.996L183.408 348.548L185.307 346.167L183.169 343.996Z"
        fill="#F6D69B"
      />
    </svg>
  )
}

export default Wheel2
